<script setup>
import { ref, inject, toRefs, watch, computed } from "vue";
import AutoComplete from "primevue/autocomplete";
import { isEqual } from "lodash";
import { getDropdownPt } from "../../styles";

const inferenceFilters = inject("inferenceFilters");
const clearFilters = inject("clearFilters");
const saveFilters = inject("saveFilters");

const props = defineProps({
  filterPath: {
    type: String,
    required: false,
  },
  displayName: {
    type: String,
  },
  getter: {
    type: Function,
  },
});

// Reactive properties
const suggestions = ref([]);
const input = ref("");
const { displayName, filterPath } = toRefs(props);
const selectedItems = ref([...inferenceFilters?.value[filterPath?.value]]);

const { data: currentSuggestions, isLoading: isLoadingList, isFetching: isFetchingList } = props.getter(10, 1, input);

watch(clearFilters, () => {
  if (inferenceFilters.value[filterPath?.value].length > 0) {
    inferenceFilters.value[filterPath?.value] = [];
  }

  selectedItems.value = [];
});

watch(saveFilters, () => {
  if (!isEqual(inferenceFilters.value[filterPath?.value], selectedItems.value)) {
    inferenceFilters.value[filterPath?.value] = selectedItems.value;
  }
});
watch(currentSuggestions, () => {
  suggestions.value = currentSuggestions.value;
});
const combinedLoading = computed(() => {
  return isLoadingList.value || isFetchingList.value;
});

const onComplete = (event) => {
  input.value = event.query;
  suggestions.value = currentSuggestions.value;
};
</script>
<template>
  <div class="flex flex-col items-end font-montserrat non-italic text-base leading-5 text-indigo-base w-full">
    <div class="flex items-center w-full pl-2 overflow-y-overlay">
      <div id="multi-search-options" class="flex items-center w-full pl-2 self-baseline">
        <div class="card flex justify-center">
          <div class="flex flex-col gap-4">
            <AutoComplete
              v-model="selectedItems"
              :option-label="displayName"
              :suggestions="suggestions"
              :loading="combinedLoading"
              :delay="500"
              multiple
              :min-length="0"
              placeholder="Search items"
              dropdown
              :pt="getDropdownPt()"
              @complete="onComplete"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
